export default "__VITE_ASSET__CDgF0xhv__"